<template>

<div class="event" :class="{'allow-multiple': maxEvents > 1}">

    <div class="event-item" v-for="(event, eventIndex) in model.events" :key="eventIndex">

        <div class="event-item-head" :class="{'is-invalid': !isValid(eventIndex)}">

            <div class="event-item-head-title">{{ (maxEvents > 1) ? label + ' #' + (eventIndex + 1) : label }}<span v-if="!isValid(eventIndex)"> - You must complete all fields</span></div>

            <div class="event-item-head-actions">
            
                <app-icon icon="add" v-tooltip="'Add new suggestion'" class="event-item-head-actions-item" v-on:click="onAddClick" v-if="model.events.length < maxEvents && eventIndex === model.events.length - 1" />
                <app-icon icon="removeCircle" v-tooltip="'Remove this suggestion'" class="event-item-head-actions-item" v-on:click="onRemoveClick(eventIndex)" v-if="model.events.length > 1" />
            
            </div>

        </div>

        <div class="event-item-inputs">

            <app-input-suggest label="Name" :disabled="disabled" v-on:custom="model.events[eventIndex].gameCustom = $event" v-model="model.events[eventIndex].game" :wide="window.is.desktop" placeholder="Search game or enter custom name..." image="image" api="bgg/game" />
            
            <app-input-text label="Description" :disabled="disabled" v-model="model.events[eventIndex].description" :autogrow="true" placeholder="(optional) Enter a description of the event..." :wide="window.is.desktop" />

            <app-input-scheduletime v-on:picker="$emit('picker', $event)" :has-picker="hasPicker" :room="room" :label="(preferredTimes > 1) ? timeLabel + ' - #' + (scheduleIndex + 1) : timeLabel" v-for="(scheduletime, scheduleIndex) in event.scheduletime" :key="scheduleIndex" :disabled="disabled" v-model="model.events[eventIndex].scheduletime[scheduleIndex]" :wide="window.is.desktop" />

            <app-input-toggle label="How many players?" :disabled="disabled" v-model="model.events[eventIndex].seats" :options="seatOptions" :full-width="true" :wide="window.is.desktop" />

            <app-input-toggle label="Are you playing?" :disabled="disabled" v-model="model.events[eventIndex].host" :options="hostOptions" :full-width="true" :wide="window.is.desktop" />

            <app-input-text v-if="askLocation" label="Where in the room is it?" :disabled="disabled" v-model="model.events[eventIndex].location" :autogrow="true" placeholder="(optional) Describe where the event will be if you already know..." :wide="window.is.desktop" />

        </div>

    </div>

</div>

</template>

<script>

import Vue from 'vue'

export default {

	props: ['label', 'room', 'wide', 'messages', 'locked', 'loading', 'hasPicker', 'maxEvents', 'askLocation', 'labelTime', 'preferredTimes', 'prefix', 'validation', 'numeric', 'autogrow', 'disabled', 'value', 'noLine', 'stacked', 'placeholder', 'notes'],

    data: function() {
    
        return {
            model: {
                events: []
            },
            seatOptions: {
                1: '1',
                2: '2',
                3: '3',
                4: '4',
                5: '5',
                6: '6',
                7: '7',
                8: '8'
            },
            hostOptions: {
                0: 'Yes, I am also playing',
                1: 'No, I am just the host / organizer'
            }
        }
    
    },

    created: function() {

        if (this.value.length) {

            Vue.set(this.model, 'events', this.value)

        } else {

            this.addEvent()
        
        }

    },

    watch: {
    
        model: {
        
            deep: true,

            handler: function(n) {

                this.$emit('input', (this.isValid()) ? n.events : [])

            }

        }
    
    },

    computed: {
    
        timeLabel: function() {
        
            return (this.labelTime) ? this.labelTime : 'Preferred Time'

        },

    },

    methods: {
    
        isValid: function(index) {

            var entries = (index !== undefined) ? [this.model.events[index]] : this.model.events

            var validEntries = 0

            this.$_.each(entries, function(event) {

                var validTimes = 0
            
                this.$_.each(event.scheduletime, function(scheduletime) {
                
                    if (scheduletime.day && scheduletime.time && scheduletime.duration) validTimes++
                
                })

                if ((event.game || event.gameCustom) && event.seats > 0 && validTimes === event.scheduletime.length) validEntries++
            
            }.bind(this))

            return validEntries === entries.length

        },

        addEvent: function() {
        
            var scheduletime = []

            for(var i=1; i <= this.preferredTimes; i++) {
            
                scheduletime.push({
                    day: 0,
                    time: 0,
                    duration: 0
                })
            
            }

            this.model.events.push({
                game: 0,
                seats: 4,
                host: 0,
                description: '',
                location: '',
                gameCustom: '',
                scheduletime: scheduletime
            })

        },
    
        onAddClick: function() {

            this.addEvent()
        
        },

        onRemoveClick: function(index) {
        
            this.model.events.splice(index, 1)
        
        }
    
    }

}

</script>

<style scoped>

.event {
    margin-top: 10px;
    margin-bottom: 10px;
}

.block .event {
    width: calc(100% + 20px);
    margin-left: -10px;
}

.event:not(.allow-multiple) >>> .input.scheduletime {
    margin-bottom: 0px!important;
}

.event-item {
    margin-bottom: 20px;
}

.event.allow-multiple .event-item .input:last-child {
    margin-bottom: 10px!important;
}

.event:not(.allow-multiple) .event-item:last-child {
    margin-bottom: 0px;
}

.event-item-head {
    display: flex;
    width: 100%;
    height: 40px;
    background-color: #4082d3;
    border-radius: 4px 4px 0px 0px;
    color: #fff;
    justify-content: space-between;
    padding: 0px 10px;
}

.event:not(.allow-multiple) .event-item-head {
    display: none;
}

.event-item-head.is-invalid {
	background-color: #c55b5b;
}

.event-item-head-title {
    font-size: 14px;
    line-height: 40px;
    font-weight: 700;
}

.event-item-head-title span {
    font-weight: 400;
    opacity: 0.8;
}

.event-item-head-actions {
    display: flex;
}

.event-item-head-actions-item {
    font-size: 20px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    line-height: 40px;
    text-align: center;
}

.event.allow-multiple .event-item-inputs {
    padding: 10px 10px 0px 10px;
    background-color: #f7f7f7;
    border-radius: 0px 0px 4px 4px;
    border: 2px solid #eee;
    border-top: 0px;
}

</style>
